import './Footer.css'
//import { Link } from "react-router-dom";
import React,{useState} from 'react'
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import { useEffect } from "react";
import 'react-phone-number-input/style.css';
import BetaWaitlist from '../Beta-Waitlist/BetaWaitlist';

const Footer = ({activeKey,setActiveKey,isVisible, setIsVisible,handleCloseButtonClick,tabTitle,handleTabSelect}) => {

    const navigate = useNavigate();
    const location = useLocation();
    const [showWaitlist, setShowWaitlist] = useState(false);

       // Function to handle navigation
       const handleNavigation = (section) => {
        if (location.pathname !== "/") {
            navigate("/", { state: { scrollTo: section } });
        } else {
            scrollToSection(section);
        }
    };

     // Function to scroll to section
     const scrollToSection = (section) => {
        setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 300);
    };

       
       useEffect(() => {
        if (location.state?.scrollTo) {
            scrollToSection(location.state.scrollTo);
        }
    }, [location]);

   
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
          setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
              const headerOffset = 80; // Adjust according to your header height
              const elementPosition = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - headerOffset,
                behavior: "smooth",
              });
            }
          }, 100); // Delay to ensure DOM is loaded
        }
      }, []);
      

    return (


<>
<BetaWaitlist
showJoinWaitList={showWaitlist}
onClose={() => setShowWaitlist(false)}
onOpen={() => setShowWaitlist(true)}
/>
{/* START Footer Desktop */}
<footer className="footer footerDesktop">	
	<div className="container">
		<div className="footerTop">
			<div className="row">
				<div className="col-lg-1 col-md-1 col-sm-12 col-12">
					<div className="footerInner">
						<a className="logoFooter" href='/' alt='Go to Home Page'><img src="/img/logoFooter.svg" alt="Rentid Logo" className="img-fluid"/></a>
					</div>
				</div>	
				<div className="col-lg-3 col-md-3 col-sm-6 col-12">
					<div className="footerInner">
                        <h2>Products</h2>
                        <ul className="pageNameFooter">
                            {/* <li onClick={() => handleFooterMenuClick('home')}>Home</li> */}
                            <li><a href='rentdirect'><img src="/img/rent_direct_icon.svg" alt="rent direct" /><span>rent</span>direct</a></li>
                            <li><a href='rentid'><img src="/img/rent_id_icon.svg" alt="rent id" /><span>rent</span>ID</a></li>
                            <li><a href='rentshield'><img src="/img/rent_shield_icon.svg" alt="rent shield" /><span>rent</span>shield</a></li>
                            <li><a href='rentai'><img src="/img/rent_ai_icon.svg" alt="rent ai" /><span>rent</span>AI</a></li>
                            <li><a href='rentsuccess'><img src="/img/rent_success_icon.svg" alt="rent success" /><span>rent</span>success</a></li>
                            <li><a href='rentacademy'><img src="/img/rent_academy_icon.svg" alt="rent academy" /><span>rent</span>academy</a></li>
                        </ul>
					</div>
                    <div className="footerInner footerexp">
                        <h2>Experiences</h2>
                        <ul className="">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <li><a href='#'>Desktop</a></li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <li><a href='#'>Mobile</a></li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <li><a href='#'>App</a></li>
                        </ul>
					</div> 
					<div className="footerInner footerSignup">
                        <h2>Sign Up</h2>
                        <ul className="">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            {/* <li><BetaWaitlist  buttonText="WaitList"/></li> */}
                            <li><a onClick={() => setShowWaitlist(true)}>Waitlist</a></li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            {process.env.REACT_APP_ENABLE_BETA === "true" && (<li><a className='openModal'  data-bs-toggle="modal" data-bs-target="#exampleModal">Beta</a></li>)}
                        </ul>
					</div>
					 {/* <div className="footerInner footerApps">
                        <h2>Get App</h2>
                        <ul className="">
                            <li><a href='#'><img src="/img/apple_footer.svg" alt="rent direct" />App Store</a></li>
                            <li><a href='#'><img src="/img/google_play_footer.svg" alt="rent id" />Google Play</a></li>
                        </ul>
					</div>  */}
				</div>
				<div className="col-lg-3 col-md-3 col-sm-12 col-12 featuresFooterMain">
					<div className="footerInner">
						<h2>Features</h2>
                        <ul>
                            <li><a href="/rentdirect#SmartBookingManagement">Smart Booking Management</a></li>
                            <li><a onClick={() => handleNavigation("customizable")}>Branded Digital Experiences</a></li>
                            <li><a onClick={() => handleNavigation("fleet")}>Fleet Management Center</a></li>
                            <li><a href="/rentdirect#CustomerRelationshipTools">Customer Relationship Tools</a></li>
                            <li><a href="/rentdirect#FinancialManagement">Financial Management</a></li>
                            <li><a href="/rentdirect#AnalyticsReporting">Analytics & Reporting</a></li>
                            <li><a href="/rentid#guestverification">Realtime Guest Verification</a></li>
                            <li><a href="/rentid#AutoInsuranceValidation">Auto Insurance Validation</a></li>
                            <li><a href="/rentid#DriverIQScore">DriverIQ Score</a></li>
                            <li><a href="/rentid#NationalBlockListDatabase">National BlockList Database</a></li>
                            <li><a href="/rentid#VerificationDashboard">Verification Dashboard</a></li>
                            <li><a href="/rentid#RiskManagement">Risk Management</a></li>
                            <li><a href="/rentshield#CommercialAutoInsurance">Commercial Auto Insurance </a></li>
                            <li><a href="/rentshield#GuestProtectionPlans">Guest Protection Plans</a></li>
                            <li><a href="/rentshield#NationalRoadsideAssistance">National Roadside Assistance</a></li>
                            <li><a href="/rentshield#DigitalClaimsManagement" onClick={() => window.location.href = '/rentshield#DigitalClaimsManagement'}>Digital Claims Management</a></li>
                            <li><a href="/rentshield#CoverageSettings">Coverage Settings</a></li>
                            <li><a href="/rentsuccess#ResolutionCenter">Resolution Center</a></li>
                            <li><a href="/cancellation-and-refund-policy" target='_blank'>Cancellation Policies</a></li>
                            <li><a href="/rentdirect#BusinessEmpowerment">Business Empowerment</a></li>
                            <li><a href="/rentsuccess#rentalSupportAgent">Rental Support Agent</a></li>
                        </ul>
					</div>
				</div>

                <div className="col-lg-3 col-md-3 col-sm-12 col-12 featuresFooterMain">
					<div className="footerInner">
						<h2>Solutions</h2>
                        <ul>
                            <li><a href="/car-rental">Car Rental</a></li>
                            <li><a href="/car-sharing"> Car Sharing</a></li>
                            <li><a href="/ride-sharing"> Ride Share</a></li>
                            <li><a href="/delivery">Delivery</a></li>
                            <li><a href="/auto-dealerships">Auto Dealerships</a></li>
                            <li><a href="/service-repair">Service & Repair</a></li>
                            <li><a href="/vacation-rental">Vacation Rental</a></li>
                            <li><a href="/hotel-resort">Hotel & Resort</a></li>
                            <li><a href="/property-management">Property Mgmt</a></li>
                            <li><a href="/corporate">Corporate</a></li>
                            <li><a href="/government">Government</a></li>
                            <li><a href="/education">Education</a></li>
                            </ul>
					</div>
				</div>

				<div className="col-lg-2 col-md-2 col-sm-6 col-12">
                    <div className="footerLast">
                        <div className="footerInner footerCompany">
                            <h2>Company</h2>
                            <ul>
                                <li><a href="/about-us">About</a></li>
                            </ul>
                        </div> 

                        <div className="footerInner 3">
                            <h2>Support</h2>
                            <ul>
                                {/* <li className=""><a href="#">Resource center</a></li> */}
                                <li><a onClick={() => handleNavigation("support")}>FAQs</a></li>
                                <li><a href="/general-question">Contact</a></li>
                                <li><a href="/rentsuccess#TechnicalSupport">Technical</a></li>
                                <li><a href="/rentacademy#nationalEventsAcademyMain">National events</a></li>
                                <li><a href="/rentacademy#BehindWheel">Podcast</a></li>
                                <li><a href="/rentacademy#affiliatePartnerMain">Affiliate program</a></li>   
                                <li><a href="/blogs">Blog</a></li>                          
                            </ul>
                        </div>

                        {/* <div className="footerInner">
                            <h2>Learn</h2>
                            <ul>
                                <li><a href="/rentacademy#nationalEventsAcademyMain">National events</a></li>
                                <li><a href="/rentacademy#BehindWheel">Podcast</a></li>
                                <li><a href="/rentacademy#video-library">Video library</a></li>  
                                <li><a href="/blogs">Blog</a></li>                        
                            </ul>
                        </div> */}
                        
                        <div className="footerInner">
                            <h2>Social</h2>
                            <ul>
                                <li><a href="https://www.facebook.com/profile.php?id=100087781668300" target="_blank" rel="noreferrer" >Facebook</a></li>
                                <li><a href="https://www.linkedin.com/company/rentidinc/" target="_blank" rel="noreferrer" >LinkedIn</a></li>
                                {/* <li><a href="https://www.youtube.com/channel/UCHfKMNp9QPpsyedUSgFm7oA" target="_blank" >Youtube</a></li>   */}
                                <li><a href="https://www.instagram.com/rentid.io/" target="_blank" rel="noreferrer" >Instagram</a></li>
                               {/* <li><a href="#">TikTok</a></li>  */}
                            </ul>
                        </div>
                    </div>
				</div>			
			</div>
		</div>
	</div>
	<div className="copy">
		<div className="container">
        <div className="copyInner">
			<div className="row align-items-center">
                <div className="col-lg-8 col-md-12 col-sm-12">
					<div className="copyLeft">
                        <p>&copy; {new Date().getFullYear()} Rentid, Inc.</p>
                        <ul className="policyFooter">
                            <li><a href="/terms" target='_blank'>Legal</a></li>
                            <li><a href="/privacy" target='_blank'>Privacy Policy</a></li>
                           <li><a href="/cancellation-and-refund-policy" target='_blank'>Cancellation & Refund Policy</a></li>
                            <li><a href="/accessibility-statement" target='_blank'>Accessibility Statement</a></li> 
                        </ul>
					</div>
				</div>
				{/* <div className="col-lg-4 col-md-12 col-sm-12">
					<div className="copyRight">
                        <ul>
                            <li><a href="#" target='_blank'><img src="/img/app_store_2.svg" alt="app store" /></a></li>
                            <li><a href="#" target='_blank'><img src="/img/google_play_2.svg" alt="google play" /></a></li>
                        </ul> 
					</div>
				</div> */}
			</div>
        </div>
        </div>
	</div>
</footer>
{/* END Footer Desktop */}

{/* START Footer Mobile */}
<footer className="footer footerMobile">	
	<div className="container">
		<div className="footerTop">
			<div className="row jusify-content-between">
				<div className="col-md-2 col-sm-12 col-12">
					<div className="footerInner">
						<a className="logoFooter" href='/' alt='Go to Home Page'><img src="/img/logoFooter.svg" alt="Rentid Logo" className="img-fluid"/></a>
					</div>
				</div>	
				<div className="col-md-5 col-sm-12 col-12">
					<div className="footerInner">
                        <h2>Products</h2>
                        <ul className="pageNameFooter">
                            {/* <li onClick={() => handleFooterMenuClick('home')}>Home</li> */}
                            <li><a href='rentdirect'><img src="/img/rent_direct_icon.svg" alt="rent direct" /><span>rent</span>direct</a></li>
                            <li><a href='rentid'><img src="/img/rent_id_icon.svg" alt="rent id" /><span>rent</span>ID</a></li>
                            <li><a href='rentshield'><img src="/img/rent_shield_icon.svg" alt="rent shield" /><span>rent</span>shield</a></li>
                            <li><a href='rentai'><img src="/img/rent_ai_icon.svg" alt="rent ai" /><span>rent</span>AI</a></li>
                            <li><a href='rentsuccess'><img src="/img/rent_success_icon.svg" alt="rent success" /><span>rent</span>success</a></li>
                            <li><a href='rentacademy'><img src="/img/rent_academy_icon.svg" alt="rent academy" /><span>rent</span>academy</a></li>
                        </ul>
					</div>
                    <div className="footerInner footerexp">
                        <h2>Experiences</h2>
                        <ul className="">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <li><a href='#'>Desktop</a></li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <li><a href='#'>Mobile</a></li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <li><a href='#'>App</a></li>
                        </ul>
					</div> 
					<div className="footerInner footerSignup">
                        <h2>Sign Up</h2>
                        <ul className="">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <li><a onClick={() => setShowWaitlist(true)}>Waitlist</a></li>
                             {/* <li><BetaWaitlist  buttonText="WaitList"/></li> */}
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            {process.env.REACT_APP_ENABLE_BETA === "true" && (<li><a className='openModal'  data-bs-toggle="modal" data-bs-target="#exampleModal">Beta</a></li>)}
                        </ul>
					</div>
                    {/* <div className="footerInner footerApps">
                        <h2>Get App</h2>
                        <ul className="">
                            <li><a href='#'><img src="/img/apple_footer.svg" alt="rent direct" />App Store</a></li>
                            <li><a href='#'><img src="/img/google_play_footer.svg" alt="rent id" />Google Play</a></li>
                        </ul>
					</div>  */}
				</div>
		 
                <div className="col-md-5 col-sm-12 col-12 featuresFooterMain">
					<div className="footerInner">
						<h2>Features</h2>
                        <ul>
                            <li><a href="/rentdirect#SmartBookingManagement">Smart Booking Management</a></li>
                            <li><a onClick={() => handleNavigation("customizable")}>Branded Digital Experiences</a></li>
                            <li><a onClick={() => handleNavigation("fleet")}>Fleet Management Center</a></li>
                            <li><a href="/rentdirect#CustomerRelationshipTools">Customer Relationship Tools</a></li>
                            <li><a href="/rentdirect#FinancialManagement">Financial Management</a></li>
                            <li><a href="/rentdirect#AnalyticsReporting">Analytics & Reporting</a></li>
                            <li><a href="/rentid#guestverification">Realtime Guest Verification</a></li>
                            <li><a href="/rentid#AutoInsuranceValidation">Auto Insurance Validation</a></li>
                            <li><a href="/rentid#DriverIQScore">DriverIQ Score</a></li>
                            <li><a href="/rentid#NationalBlockListDatabase">National BlockList Database</a></li>
                            <li><a href="/rentid#VerificationDashboard">Verification Dashboard</a></li>
                            <li><a href="/rentid#RiskManagement">Risk Management</a></li>
                            <li><a href="/rentshield#CommercialAutoInsurance">Commercial Auto Insurance </a></li>
                            <li><a href="/rentshield#GuestProtectionPlans">Guest Protection Plans</a></li>
                            <li><a href="/rentshield#NationalRoadsideAssistance">National Roadside Assistance</a></li>
                            <li><a href="/rentshield#DigitalClaimsManagement" onClick={() => window.location.href = '/rentshield#DigitalClaimsManagement'}>Digital Claims Management</a></li>
                            <li><a href="/rentshield#CoverageSettings">Coverage Settings</a></li>
                            <li><a href="/rentsuccess#ResolutionCenter">Resolution Center</a></li>
                            <li><a href="/cancellation-and-refund-policy" target='_blank'>Cancellation Policies</a></li>
                            <li><a href="/rentdirect#BusinessEmpowerment">Business Empowerment</a></li>
                            <li><a href="/rentsuccess#rentalSupportAgent">Rental Support Agent</a></li>
                        </ul>
					</div>
				</div>

                <div className="col-md-2 col-sm-12 col-12">
                    </div>

                <div className="col-md-5 col-sm-12 col-12 featuresFooterMain">
					<div className="footerInner">
						<h2>Solutions</h2>
                        <ul>
                            <li><a href="/car-rental">Car Rental</a></li>
                            <li><a href="/car-sharing"> Car Sharing</a></li>
                            <li><a href="/ride-sharing"> Ride Share</a></li>
                            <li><a href="/delivery">Delivery</a></li>
                            <li><a href="/auto-dealerships">Auto Dealerships</a></li>
                            <li><a href="/service-repair">Service & Repair</a></li>
                            <li><a href="/vacation-rental">Vacation Rental</a></li>
                            <li><a href="/hotel-resort">Hotel & Resort</a></li>
                            <li><a href="/property-management">Property Mgmt</a></li>
                            <li><a href="/corporate">Corporate</a></li>
                            <li><a href="/government">Government</a></li>
                            <li><a href="/education">Education</a></li>
                        </ul>
					</div>
				</div>


				<div className="col-md-5 col-sm-12 col-12">
                    <div className="footerLast">
                        <div className="footerInner footerCompany">
                            <h2>Company</h2>
                            <ul>
                                <li><a href="/about-us">About</a></li>
                            </ul>
                        </div> 

                        <div className="footerInner 3">
                            <h2>Support</h2>
                            <ul>
                                {/* <li className=""><a href="#">Resource center</a></li> */}
                                <li><a onClick={() => handleNavigation("support")}>FAQs</a></li>
                                <li><a href="/general-question">Contact</a></li>
                                <li><a href="/rentsuccess#TechnicalSupport">Technical</a></li>
                                <li><a href="/rentacademy#nationalEventsAcademyMain">National events</a></li>
                                <li><a href="/rentacademy#BehindWheel">Podcast</a></li>
                                <li><a href="/rentacademy#affiliatePartnerMain">Affiliate program</a></li>   
                                <li><a href="/blogs">Blog</a></li>                          
                            </ul>
                        </div>

                        {/* <div className="footerInner">
                            <h2>Learn</h2>
                            <ul>
                                <li><a href="/rentacademy#nationalEventsAcademyMain">National events</a></li>
                                <li><a href="/rentacademy#BehindWheel">Podcast</a></li>
                                <li><a href="/rentacademy#video-library">Video library</a></li>  
                                <li><a href="/blogs">Blog</a></li>                        
                            </ul>
                        </div> */}
                        
                        <div className="footerInner">
                            <h2>Social</h2>
                            <ul>
                                <li><a href="https://www.facebook.com/profile.php?id=100087781668300" target="_blank" rel="noreferrer" >Facebook</a></li>
                                <li><a href="https://www.linkedin.com/company/rentidinc/" target="_blank" rel="noreferrer" >LinkedIn</a></li>
                                {/* <li><a href="https://www.youtube.com/channel/UCHfKMNp9QPpsyedUSgFm7oA" target="_blank" >Youtube</a></li>   */}
                                <li><a href="https://www.instagram.com/rentid.io/" target="_blank" rel="noreferrer" >Instagram</a></li>
                               {/* <li><a href="#">TikTok</a></li>  */}
                            </ul>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	</div>
	<div className="copy">
		<div className="container">
            <div className="copyInner">
                <div className="row align-items-center">
                    <div className="col-md-8 col-sm-12 col-12">
                        <div className="copyLeft">
                            {/* <div className="dropdown">
                                <a className="btn dropdown-toggle" href="#" role="button" id="dropdownMenuLink_1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img src="/img/flags.svg" className="img-fluid"/> USA
                                </a> 

                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink_1">
                                    <li><a className="dropdown-item" href="#"><img src="/img/flags.svg" className="img-fluid"/> USA</a></li>
                                    <li><a className="dropdown-item" href="#"><img src="/img/flags.svg" className="img-fluid"/> USA</a></li>
                                </ul> 
                            </div> */}

                            <p>&copy; {new Date().getFullYear()} Rentid, Inc.</p>
                            <ul className='policyFooter'>
                                <li><a href="/terms" target='_blank'>Legal</a></li>
                                <li><a href="/privacy" target='_blank'>Privacy Policy</a></li>
                                <li><a href="/cancellation-and-refund-policy" target='_blank'>Cancellation & Refund Policy</a></li>
                                <li><a href="/accessibility-statement" target='_blank'>Accessibility Statement</a></li> 
                            </ul>
                        </div>
                    </div>
                    {/* <div className="col-lg-4 col-md-12 col-sm-12">
                        <div className="copyMiddle">
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/profile.php?id=100087781668300" target="_blank" rel="noreferrer">
                                        <img src="/img/facebook-01.svg" alt="" width="20" />
                                    </a>
                                </li>

                                    <li>
                                    <a href="https://www.youtube.com/channel/UCHfKMNp9QPpsyedUSgFm7oA" target="_blank">
                                        <img src="/img/youtube.svg" alt="" width="20" />
                                    </a>
                                </li> 

                                <li>
                                    <a href="https://www.instagram.com/rentid.io/" target="_blank" rel="noreferrer">
                                        <img src="/img/instagram.svg" alt="Instagram" width="20" />
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/rentidinc/" target="_blank" rel="noreferrer">
                                        <img src="/img/linkedin-01.svg" alt="LinkedIn" width="20" />
                                    </a>
                                </li>
                                <li>
                                    <a href="#" target="_blank" rel="noreferrer">
                                        <img src="/img/tiktok.svg" alt="tiktok" width="20" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div> */}
                    {/* <div className="col-md-4 col-sm-12 col-12">
                        <div className="copyRight">
                        <ul>
                                <li><a href="#" target='_blank'><img src="/img/app_store_2.svg" alt="app store" /></a></li>
                                <li><a href="#" target='_blank'><img src="/img/google_play_2.svg" alt="google play" /></a></li>
                            </ul>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
	</div>
</footer>
{/* END Footer Desktop */}
</>
 
    );
};

export default Footer;
